import * as React from 'react';

import type { Xinglet } from '@xingternal/crate-xinglet';

import { StartPageLoggedOut } from './startpage-logged-out';

export default class Entry implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <StartPageLoggedOut />;
  }
}
